export { TruncateModule, TRUNCATE_PIPES } from './truncate.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/ng2-truncate/dist/index.js
// module id = ../../../../ng2-truncate/dist/index.js
// module chunks = 4